import styled from "styled-components";
import { mobileQueryMedia } from "./MediaQuery";

export const SizedBox = styled.div<{
  width?: number;
  desktopWidth?: number;
  mobileWidth?: number;
  height?: number;
  desktopHeight?: number;
  mobileHeight?: number;
}>`
  flex-shrink: 0;

  width: ${(props) => props.desktopWidth ?? props.width ?? 0}px;
  height: ${(props) => props.desktopHeight ?? props.height ?? 0}px;

  ${mobileQueryMedia} {
    width: ${(props) => props.mobileWidth ?? props.width ?? 0}px;
    height: ${(props) => props.mobileHeight ?? props.height ?? 0}px;
  }
`;
